export const DEFAULT_COUNTRY = "VN";
export const DEFAULT_CURRENCY = "VND";
export const LIST_DEFAULT_COUNTRY = ["VN", "NO"];
export const DEFAULT_PER_PAGE_STORES = 20;
export const DEFAULT_PER_PAGE_SEARCH_BAR_STORES = 6;

export const DEFAULT_IP_CONFIG = {
  SG: {
    CURRENCY: "SGD",
    LOCALE: "en"
  },
  NO: {
    CURRENCY: "NOK",
    LOCALE: "en"
  },
  VN: {
    CURRENCY: "VND",
    LOCALE: "vi"
  }
}

export const DEVICE = {
  desktop: "d",
  mobile: "m",
}

export const FEATURE_STATUS = {
  UNKNOW: "unknow",
  ACTIVE: "active",
  DEACTIVE: "deactive",
}


export const LIST_QUERYSTRING = {
  AUTH: {
    PHONE: "f_auth_phone",
    EMAIL: "f_auth_email",
    FACEBOOK: "f_auth_facebook",
    APPLE: "f_auth_apple",
    GOOGLE: "f_auth_google",
  },
  CHECKOUT: {
    STRIPE_APPLE: "f_checkout_stripe_apple",
    STRIPE_GOOGLE: "f_checkout_stripe_google",
  },
  MERCHANT_FILTER: {
    DATE_RANGE: "f_merchant_filter_date",
    COUNTRY: "f_merchant_filter_country",
  }
}

export const STATUS_ORDER = {
  CREATE: "create",
  CONFIRM_PAYMENT: "confirm_payment",
  RECEIVE_PAYMENT: "receive_payment",
  PROCESS_PURCHASE: "complete_purchase",
  ARRIVED_AT_US_WAREHOUSE: "received_at_origin_warehouse",
  ARRIVED_AT_VN_WAREHOUSE: "received_at_destination_warehouse",
  SHIPPING_IN_VN: "shipping_in_vietnam",
  ORDER_COMPLETED: "order_completed",
  CANCEL: "cancel"
}

export const STATUS_ORDER_LIST = [
  {
    id: STATUS_ORDER.CANCEL,
    index: 70,
    status: "cancel",
    statusOf: "trackingOrder_user",
  },
  {
    id: STATUS_ORDER.ORDER_COMPLETED,
    index: 60,
    status: "completed",
    statusOf: "trackingOrder_dutycast",
  },
  {
    id: STATUS_ORDER.ARRIVED_AT_VN_WAREHOUSE,
    index: 50,
    status: "vn-warehouse",
    statusOf: "trackingOrder_merchant",
  },
  {
    id: STATUS_ORDER.ARRIVED_AT_US_WAREHOUSE,
    index: 40,
    status: "us-warehouse",
    statusOf: "trackingOrder_merchant",
  },
  {
    id: STATUS_ORDER.PROCESS_PURCHASE,
    index: 30,
    status: "complete-purchase",
    statusOf: "trackingOrder_dutycast",
  },
  {
    id: STATUS_ORDER.RECEIVE_PAYMENT,
    index: 20,
    status: "receive-payment",
    statusOf: "trackingOrder_user",
  },
  {
    id: STATUS_ORDER.CONFIRM_PAYMENT,
    index: 15,
    status: "confirm-payment",
    statusOf: "trackingOrder_user",
  },
  {
    id: STATUS_ORDER.CREATE,
    index: 10,
    status: "create",
    statusOf: "trackingOrder_user",
  }
]
